import { jwtDecode } from "jwt-decode"
import { PinTokenType } from "../types/portalTypes/PinTokenType"

export function errorifInvalidPin(pin: string | null): asserts pin is string {
  if (!pin) { throw new Error('You might be logged out', { cause: 'no_pin_token' }) }

  try {
    jwtDecode<PinTokenType>(pin)
  } catch (error) {
    console.error("Invalid token format", error)
    throw new Error('Unknown error.', { cause: 'invalid_jwt' })
  }
}
